import { HStack, Icon, IconButton, Text } from '@chakra-ui/react';
import { ArrowBackIcon, ArrowForwardIcon } from '@chakra-ui/icons';
import { HiChevronDoubleLeft, HiChevronDoubleRight } from 'react-icons/hi2';
import { pageButtonProps, pageMetaTextProps } from '@/theme/sitePageTypography';

export function LeaderboardPageControls(props: {
  pageIndex: number;
  totalPages: number;
  canGoFirst: boolean;
  canGoPrev: boolean;
  canGoNext: boolean;
  canGoLast: boolean;
  onFirst: () => void;
  onPrev: () => void;
  onNext: () => void;
  onLast: () => void;
  placement: 'top' | 'bottom';
}) {
  const {
    pageIndex,
    totalPages,
    canGoFirst,
    canGoPrev,
    canGoNext,
    canGoLast,
    onFirst,
    onPrev,
    onNext,
    onLast,
    placement,
  } = props;

  return (
    <HStack
      spacing={1}
      mb={placement === 'top' ? 2 : 0}
      mt={placement === 'bottom' ? 2 : 0}
      w='full'
      justify='center'
      flexWrap='wrap'
    >
      <IconButton
        {...pageButtonProps}
        bg='transparent'
        icon={<Icon as={HiChevronDoubleLeft} boxSize={3} />}
        aria-label='First page'
        isDisabled={!canGoFirst}
        onClick={onFirst}
      />
      <IconButton
        {...pageButtonProps}
        bg='transparent'
        icon={<ArrowBackIcon boxSize={3} />}
        aria-label='Previous page'
        isDisabled={!canGoPrev}
        onClick={onPrev}
      />
      <Text {...pageMetaTextProps}>
        {pageIndex + 1} / {totalPages}
      </Text>
      <IconButton
        {...pageButtonProps}
        bg='transparent'
        icon={<ArrowForwardIcon boxSize={3} />}
        aria-label='Next page'
        isDisabled={!canGoNext}
        onClick={onNext}
      />
      <IconButton
        {...pageButtonProps}
        bg='transparent'
        icon={<Icon as={HiChevronDoubleRight} boxSize={3} />}
        aria-label='Last page'
        isDisabled={!canGoLast}
        onClick={onLast}
      />
    </HStack>
  );
}
